import { RadioSwatch_default } from "./chunk-T4LCHGLF.js";
import { CheckableGroupComponent } from "./chunk-74SYDCTI.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioSwatchGroup/RadioSwatchGroup.Field.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var RadioSwatchGroupField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent.Field, __spreadProps(__spreadValues({}, rest), {
    as: RadioSwatch_default,
    ref,
    className
  }));
});
var RadioSwatchGroup_Field_default = RadioSwatchGroupField;
export { RadioSwatchGroup_Field_default };